/**
 * Implementation details
 */

function getExportRawDataOptions(object) {
  return { model: object.model, exportDataPath: '/qUndoExclude/box/qHyperCubeDef' };
}

export default {
  getExportRawDataOptions,
};
